import { render } from "./LearningCard.vue?vue&type=template&id=433bbbc1&scoped=true"
import script from "./LearningCard.vue?vue&type=script&lang=js"
export * from "./LearningCard.vue?vue&type=script&lang=js"

import "./LearningCard.vue?vue&type=style&index=0&id=433bbbc1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433bbbc1"]])

export default __exports__